import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=d1040d74"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=d1040d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports